import customFieldsApi from "@/services/api.customField.service";
import { ActionTree } from "vuex";
import { PaginatedSearchQueryParamsCustomField, RootState } from "../types";
import { CustomFieldsState, CustomFieldTableTypes } from "./types";
import PagedResponse from "@/types/sv-data/PagedResponse";
import { paginatedSearchExtendedMixins } from "@/mixins/paginatedSearchExtendedMixins";

const { generateNewPaginatedSearchQueryParamsCustomField, fetchAllResults } =
		paginatedSearchExtendedMixins.methods;

export const actions: ActionTree<CustomFieldsState, RootState> = {
	async retrieveCustomFields({ commit }, { tableType, live, skipCancel = false, excludeTypeIds = null }) {
		const params: PaginatedSearchQueryParamsCustomField = {
			customFieldTableType: tableType,
			page: 1,
			pageSize: 250,
			live: live,
			excludeTypeIds: excludeTypeIds,
		}

		const request = generateNewPaginatedSearchQueryParamsCustomField(params, skipCancel);

		const results = await fetchAllResults<PagedResponse>(customFieldsApi, customFieldsApi.retrieveCustomFields, request);

		switch(tableType) {
			case CustomFieldTableTypes.Area:
				commit("setAreaCustomFields", results);
				break;
			case CustomFieldTableTypes.Contact:
				commit("setContactCustomFields", results);
				break;
			case CustomFieldTableTypes.Alarm:
				commit("setAlarmCustomFields", results);
				break;
			case CustomFieldTableTypes.Server:
				commit("setServerCustomFields", results);
				break;
			case CustomFieldTableTypes.Device:
				commit("setDeviceCustomFields", results);
				break;
			case CustomFieldTableTypes.NotificationTemplate:
				commit("setNotificationTemplateCustomFields", results);
				break;
		}
	},
};
